import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { saveBenefitType, updateBenefitType } from '../../services/api.service';

const BenefitTypeForm = ({ closeModal, isEdit, benefitType }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const form = useForm({
		initialValues: {
			name: '',
		},
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			name: benefitType.name,
		});
		// eslint-disable-next-line
	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveBenefitType(values, function () {

				// Show success
				notifications.show({
					title: 'Tipo de beneficio creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateBenefitType(benefitType.id, values, function () {

				// Show success
				notifications.show({
					title: 'Tipo de beneficio modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información del Tipo de Beneficio
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* Name */}
					<TextInput
						required
						label="Nombre"
						placeholder="Nombre del tipo de beneficio"
						value={form.values.name}
						onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
						{...form.getInputProps('name')}
					/>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Tipo de Beneficio'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default BenefitTypeForm;
